import { Box, IconButton, Paper, Typography } from '@mui/material';
import type React from 'react';

import CloseIcon from '../../assets/close.svg?react';
import ErrorIcon from '../../assets/error.svg?react';
import useStyles from './ToastMessage.styles';

export enum TOAST_STATUS {
  ERROR = 'error',
}

interface ToastMessageProps {
  message: string;
  status: TOAST_STATUS;
  testId: string;
  onClose: () => void;
}

export const ToastMessage: React.FC<ToastMessageProps> = ({
  message,
  status,
  testId,
  onClose,
}) => {
  const { classes } = useStyles();

  const toastIcon =
    status === TOAST_STATUS.ERROR ? (
      <Box component="span" data-testid="toast-error-icon">
        <ErrorIcon aria-hidden className={classes.toastIconError} />
      </Box>
    ) : null;

  return (
    <Paper
      elevation={6}
      className={`toast-${status} ${classes.toastMessage}`}
      data-testid={testId}
      role="alert"
    >
      {toastIcon}
      <Box ml={1} flex={1}>
        <Typography variant="body_medium" data-testid="toast-label">
          {message}
        </Typography>
      </Box>
      <IconButton
        aria-label="Dismiss"
        color="inherit"
        className={classes.toastIconButton}
        onClick={onClose}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            onClose();
          }
        }}
        data-testid="toast-message-close"
        size="small"
        tabIndex={0}
      >
        <CloseIcon
          className={classes.toastIconClose}
          data-testid="toast-close-icon"
          aria-hidden
        />
      </IconButton>
    </Paper>
  );
};

export default ToastMessage;
